import React from 'react';
import LegalLayout from './LegalLayout';

/**
 * Widerrufsbelehrung. Separate page because § 312d KSchG / Art. 11
 * RL 2011/83/EU require it to be findable independently of the AGB.
 *
 * Adapted to Real Content / REALTECHSOLUTIONS, S.L. The 14-Tage
 * standard window applies, with the digital-services waiver clause
 * that lets us start the service immediately on subscription instead
 * of waiting two weeks. The waiver is opt-in (the register checkbox
 * + first paid checkout count as the "ausdrückliche Zustimmung").
 */
export default function WiderrufsrechtPage() {
  return (
    <LegalLayout title="Widerrufsbelehrung">
      <p>
        <strong>Stand:</strong> 29. April 2026
      </p>

      <h2>Widerrufsrecht</h2>
      <p>
        Sie haben das Recht, binnen 14 Tagen ohne Angabe von Gründen
        diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt 14
        Tage ab dem Tag des Vertragsabschlusses.
      </p>

      <h2>Ausübung des Widerrufsrechts</h2>
      <p>
        Um Ihr Widerrufsrecht auszuüben, müssen Sie uns:
      </p>
      <p>
        <strong>REALTECHSOLUTIONS, S.L.</strong><br />
        Calle Galicia, Num 9, Bloque B, Planta Baja, Puerta 3<br />
        35660 Corralejo, La Oliva, Fuerteventura, Spanien<br />
        E-Mail: <a href="mailto:info@real-content.at">info@real-content.at</a>
      </p>
      <p>
        mittels einer eindeutigen Erklärung (z. B. ein mit der Post
        versandter Brief oder eine E-Mail) über Ihren Entschluss,
        diesen Vertrag zu widerrufen, informieren. Sie können dafür das
        unten beigefügte Muster-Widerrufsformular verwenden, das jedoch
        nicht vorgeschrieben ist. Zur Wahrung der Widerrufsfrist reicht
        es aus, dass Sie die Mitteilung über die Ausübung des
        Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
      </p>

      <h2>Folgen des Widerrufs</h2>
      <p>
        Wenn Sie diesen Vertrag widerrufen, erstatten wir Ihnen alle
        Zahlungen, die wir von Ihnen erhalten haben, unverzüglich und
        spätestens binnen 14 Tagen ab dem Tag, an dem die Mitteilung
        über Ihren Widerruf bei uns eingegangen ist. Für die Rückzahlung
        verwenden wir dasselbe Zahlungsmittel, das Sie bei der
        ursprünglichen Transaktion eingesetzt haben (in der Regel
        Kreditkarte über Stripe). Es entstehen für Sie wegen dieser
        Rückzahlung keine Entgelte.
      </p>

      <h2>Vorzeitiges Erlöschen des Widerrufsrechts</h2>
      <p>
        Bei einem Vertrag über die Lieferung von nicht auf einem
        körperlichen Datenträger befindlichen digitalen Inhalten (wie
        es bei Real Content der Fall ist) erlischt das Widerrufsrecht,
        wenn wir mit der Ausführung des Vertrags begonnen haben, nachdem
        Sie:
      </p>
      <ul>
        <li>ausdrücklich zugestimmt haben, dass wir mit der Ausführung
          des Vertrags vor Ablauf der Widerrufsfrist beginnen, und</li>
        <li>Ihre Kenntnis davon bestätigt haben, dass Sie durch Ihre
          Zustimmung mit Beginn der Ausführung des Vertrags Ihr
          Widerrufsrecht verlieren.</li>
      </ul>
      <p>
        <strong>Konkret:</strong> Mit dem Abschluss eines kostenpflichtigen
        Abonnements und der Inanspruchnahme der ersten Rendering-Leistung
        (z. B. Erstellung eines Videos) erteilen Sie uns diese
        ausdrückliche Zustimmung und bestätigen, dass Ihr Widerrufsrecht
        nach vollständiger Erfüllung erlischt.
      </p>

      <h2>Muster-Widerrufsformular</h2>
      <p>
        (Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte
        dieses Formular aus und senden Sie es zurück.)
      </p>
      <p>
        An: <strong>REALTECHSOLUTIONS, S.L.</strong>, Calle Galicia, Num 9,
        Bloque B, Planta Baja, Puerta 3, 35660 Corralejo, La Oliva,
        Fuerteventura, Spanien. E-Mail:{' '}
        <a href="mailto:info@real-content.at">info@real-content.at</a>
        <br /><br />
        Hiermit widerrufe(n) ich/wir <span style={{ background: '#1f2937', padding: '0 4px' }}>(*)</span> den von
        mir/uns <span style={{ background: '#1f2937', padding: '0 4px' }}>(*)</span> abgeschlossenen Vertrag
        über die Erbringung der folgenden Dienstleistung:
        <br /><br />
        Bestellt am: ____________&nbsp;&nbsp;&nbsp;Erhalten am: ____________<br /><br />
        Name des/der Verbraucher(s): ___________________________________<br />
        Anschrift des/der Verbraucher(s): ______________________________<br />
        Datum + Unterschrift (nur bei Mitteilung auf Papier): ___________
      </p>
      <p style={{ fontSize: '0.85rem', opacity: 0.7 }}>
        (*) Unzutreffendes streichen.
      </p>
    </LegalLayout>
  );
}
